import SearchResultsDashboard from './SearchResultsDashboard'

export default SearchResultsDashboard
